export default __webpack_public_path__ + "static/media/Giants.d5200ec3.png";